'use client'

import { useEffect, useState } from 'react'

export default function PageTransitionLoader() {
  const [loading, setLoading] = useState(false)
  const [currentUrl, setCurrentUrl] = useState('')

  useEffect(() => {
    if (typeof window === 'undefined') return
    setCurrentUrl(window.location.pathname + window.location.search)
    setLoading(false)
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return

    const syncUrl = () => {
      setCurrentUrl(window.location.pathname + window.location.search)
      setLoading(false)
    }

    syncUrl()
    window.addEventListener('popstate', syncUrl)

    return () => window.removeEventListener('popstate', syncUrl)
  }, [])

  // Capturar clicks en enlaces para feedback instantáneo
  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement
      const anchor = target.closest('a')
      
      if (anchor && anchor.href && 
          anchor.href.startsWith(window.location.origin) && 
          !anchor.href.includes('#') &&
          anchor.target !== '_blank' &&
          anchor.href !== window.location.href) {
        setLoading(true)
      }
    }

    document.addEventListener('click', handleClick)
    return () => document.removeEventListener('click', handleClick)
  }, [])

  useEffect(() => {
    if (typeof window === 'undefined') return

    let timeoutId: ReturnType<typeof setTimeout> | null = null

    if (loading) {
      timeoutId = setTimeout(() => {
        const nextUrl = window.location.pathname + window.location.search
        if (nextUrl !== currentUrl) {
          setCurrentUrl(nextUrl)
        }
        setLoading(false)
      }, 1200)
    }

    return () => {
      if (timeoutId) clearTimeout(timeoutId)
    }
  }, [loading, currentUrl])

  if (!loading) return null

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] h-1.5 overflow-hidden bg-white/10 backdrop-blur-sm">
      <div className="h-full bg-gradient-to-r from-cyan-400 via-blue-500 to-indigo-600 animate-ultra-progress"></div>
      <style jsx>{`
        @keyframes ultra-progress {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(0); }
        }
        .animate-ultra-progress {
          animation: ultra-progress 0.5s cubic-bezier(0.1, 0, 0.45, 1) forwards;
        }
      `}</style>
    </div>
  )
}
